
import React, { Component } from 'react';
class Loginslider extends React.Component {
  componentDidMount() {
  }
  render() {
    return (
<>
<div className='left-loginside'>
  <div className='row g-2'>
    <div className='col-md-3'>
      <div className='inner-div'>
        <img src='images/login/2.png'/>
      </div>
      <div className='inner-div'>
        <img src='images/login/3.png'/>
      </div>
      <div className='inner-div'>
        <img src='images/login/4.png'/>
      </div>
    </div>
    <div className='col-md-3'>
      <div className='inner-div'>
        <img src='images/login/6.png'/>
      </div>
      <div className='inner-div'>
        <img src='images/login/5.png'/>
      </div>
      <div className='inner-div'>
        <img src='images/login/7.png'/>
      </div>
    </div>
    <div className='col-md-3'>
    <div className='inner-div'>
        <img src='images/login/9.png'/>
      </div>
      <div className='inner-div'>
        <img src='images/login/8.png'/>
      </div>
      <div className='inner-div'>
        <img src='images/login/1.png'/>
      </div>
    </div>
   
  </div>
</div>
<div className="slideshow d-none">
  <div className="slideshow-image" style={{"backgroundImage": "url('./images/org-img/figure/3.png')"}}></div>
<div className="slideshow-image" style={{"backgroundImage": "url('./images/org-img/figure/4.png')"}}></div>
<div className="slideshow-image" style={{"backgroundImage": "url('./images/org-img/figure/5.png')"}}></div>
<div className="slideshow-image" style={{"backgroundImage": "url('./images/org-img/figure/6.png')"}}></div>
</div>
</>
    )
  }
}
export default Loginslider